import React from 'react';
import { ChevronRight, MoreVertical } from 'lucide-react';

/**
 * Lista móvil con diseño de tarjetas
 * Optimizada específicamente para dispositivos móviles
 */
export default function MobileList({ 
  items = [], 
  onItemClick, 
  renderMobileCard, 
  emptyMessage = "No hay elementos para mostrar",
  className = "" 
}) {
  if (items.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={`mobile-view space-y-3 ${className}`}>
      {items.map((item, index) => (
        <div 
          key={item.id || index}
          className="bg-white rounded-lg shadow border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow"
          onClick={() => onItemClick && onItemClick(item)}
        >
          {renderMobileCard(item, index)}
        </div>
      ))}
    </div>
  );
}

/**
 * Componentes auxiliares para móvil
 */
export function MobileFilters({ children }) {
  return (
    <div className="mb-4 space-y-3 bg-white rounded-lg shadow p-4">
      {children}
    </div>
  );
}

export function MobileSearch({ value, onChange, placeholder }) {
  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-base"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>
  );
}

export function MobileListActions({ children }) {
  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {children}
    </div>
  );
}

export function MobilePagination({ currentPage, totalPages, onPageChange }) {
  return (
    <div className="flex justify-between items-center mt-6 bg-white rounded-lg shadow p-4">
      <button
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg disabled:opacity-50"
      >
        Anterior
      </button>
      <span className="text-sm text-gray-600">
        Página {currentPage} de {totalPages}
      </span>
      <button
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-4 py-2 text-sm bg-emerald-600 text-white rounded-lg disabled:opacity-50"
      >
        Siguiente
      </button>
    </div>
  );
}